import React from 'react'
import useSiteSettings from '../hooks/useSiteSettings'

const Footer = () => {
  const { siteName, siteTagline, contactPhone, contactEmail } = useSiteSettings()

  return (
    <footer className="text-center text-muted footer-shell mt-auto">
      <div className="container">
        <p className="mb-1">&copy; {new Date().getFullYear()} {siteName}. All rights reserved.</p>
        <p className="mb-1">{siteTagline}</p>
        <p className="mb-0">{contactPhone} | {contactEmail}</p>
      </div>
    </footer>
  )
}

export default Footer
